<template>
    <div class="columns" v-if="hasBroadAccess || bundles.length > 0">
        <div class="column">
            <div class="is-flex is-justify-content-center is-flex-wrap-wrap" style="gap: 1rem">
                <a v-if="hasBroadAccess || bundles.includes(BUNDLE_VERIFICATION_DESK)" :href="urls.eventAdmin().verificationPage(eventId)">
                    <span class="icon">
                        <i class="fa fa-user-check" />
                    </span>
                    <span>
                        {{ translate("page.admin_edit_event_settings.verification.button") }}
                    </span>
                </a>

                <a v-if="hasBroadAccess || bundles.includes(BUNDLE_REFEREE)" :href="urls.eventAdmin().refereeFightsPage(eventId)">
                    <span class="icon">
                        <i class="fa fa-bolt" />
                    </span>
                    <span>
                        {{ translate("admin.menu.organization.start_fights") }}
                    </span>
                </a>

                <a v-if="bundles.includes(BUNDLE_ANNOUNCER)" :href="urls.eventAdmin().announcerBoardPage(eventId)">
                    <span class="icon">
                        <i class="fa fa-bullhorn" />
                    </span>
                    <span>
                        {{ translate("admin.menu.organization.announcer_board") }}
                    </span>
                </a>

                <a v-if="hasBroadAccess" :href="urls.eventAdmin().activeScheduleDelayPage(eventId)">
                    <span class="icon">
                        <i class="far fa-clock" />
                    </span>
                    <span>
                        {{ translate("page.admin_edit_event_settings.schedule_delay.button") }}
                    </span>
                </a>

                <a
                    v-if="hasBroadAccess || bundles.includes(BUNDLE_RESULTS_DECORATION)"
                    :href="urls.eventAdmin().competitorResultsPage(eventId)"
                >
                    <span class="icon">
                        <i class="fa fa-poll" />
                    </span>
                    <span>
                        {{ translate("page.admin_edit_event_settings.competitor_results.button") }}
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import urls from "../Urls/urls";
    import { translate } from "../Common/translations";
    import { Bundle, BUNDLE_ANNOUNCER, BUNDLE_REFEREE, BUNDLE_RESULTS_DECORATION, BUNDLE_VERIFICATION_DESK } from "../Common/consts";

    defineProps<{
        eventId: number;
        bundles: Bundle[];
        hasBroadAccess: boolean;
    }>();
</script>

<style scoped></style>
